import { useEffect, useRef, useState } from 'react';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    time: {
        cursor: 'text',
        borderBottom: '2px dashed transparent',
        '&:hover': {
            borderBottomColor: theme.palette.divider
        }
    },
    input: {
        font: 'inherit',
        color: 'inherit',
        background: 'transparent',
        border: 'none',
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        textAlign: 'center',
        outline: 'none',
        padding: 0
    }
}));

// The time on a waiting screen, set by double clicking it. It is the operator's
// own note of when they mean to be back, so it is kept in the browser rather
// than on the match.
function EditableTime(props) {
    const classes = useStyles();
    const [editing, setEditing] = useState(false);
    const input = useRef(null);

    useEffect(() => {
        if (editing && input.current != null) input.current.focus();
    }, [editing]);

    if (editing) {
        return (
            <input
                ref={input}
                className={classes.input}
                type='time'
                value={props.value ?? ''}
                onChange={event => props.onChange(event.target.value)}
                onBlur={() => setEditing(false)}
                onKeyDown={event => {
                    // the slideshow moves on the arrow keys, which belong to the
                    // input while it is being typed into
                    event.stopPropagation();
                    if (event.key === 'Enter' || event.key === 'Escape') setEditing(false);
                }}
            />
        );
    }
    return (
        <Typography
            component='span'
            variant='inherit'
            className={classes.time}
            onDoubleClick={() => setEditing(true)}
            title='Double click to set the time'
        >
            {props.value ? props.value : '--:--'}
        </Typography>
    );
}

export default EditableTime;
